import mapboxgl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { mapToken } from "@/constants/tokens";
import { ModesController } from "@/libs/map-draw/modes/modes-controller";
import {
  BaseController,
  EditorController,
  FillController
} from "../controllers";
import { editorStyles } from "@/libs/map-draw/config";
import { getMapParams } from "@/utils";

export const initMap = component => {
  // map creation
  const { center, zoom } = getMapParams("tcMap", component.$store);
  // const theme = component.$store.state.theme;
  // const disabledTiles = theme === "dark-theme" ? "light-theme" : "dark-theme";

  mapboxgl.accessToken = mapToken;

  component.mapgl = new mapboxgl.Map({
    container: "traffic-count-map",
    style: "mapbox://styles/aplussmoscow/ckea67vfv6oxu1aoxuaikbgvm",
    center,
    zoom
  });

  // component.mapgl.on("load", () =>
  //   component.mapgl.setLayoutProperty(disabledTiles, "visibility", "none")
  // );

  // view handlers
  component.mapgl.on("pitch", e => {
    component.is3d = e.target.getPitch() !== 0;
  });
  component.mapgl.on("rotate", e => {
    component.mapBearing = e.target.getBearing();
  });

  // edit and fill modes controllers
  const mc = new ModesController(component, MapboxDraw, "editorState");
  component.draw = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
      line_string: true,
      point: true,
      polygon: true,
      trash: true
    },
    styles: editorStyles,
    userProperties: true,
    modes: Object.assign(MapboxDraw.modes, {
      draw_general_count_points: mc.createDrawGeneralCountPointMode(),
      traffic_counts_simple_select: mc.createTCSimpleSelectMode(),
      traffic_counts_direct_select: mc.createTCDirectSelectMode()
    })
  });

  component.BaseController = new BaseController(component);
  component.EditorController = new EditorController(component);
  component.EditorController.initDrawListeners();
  component.FillController = new FillController(
    component,
    component.BaseController
  );

  component.mapgl.addControl(component.draw);

  window.addEventListener("beforeunload", component.saveMapParams);
};
